//actions for redux to be executed
export const ActionTypes = {
    //Prvky reducer
    SET_POVRCHY: "SET_POVRCHY",
    SET_DOPLNKY: "SET_DOPLNKY",
    SET_VYBAVENI: "SET_VYBAVENI",
    
    //Deprecate
    SELECTED_POVRCH: "SELECTED_POVRCH",
    REMOVE_SELECTED_POVRCH: "REMOVE_SELECTED_POVRCH",
    SELECTED_DOPLNEK: "SELECTED_DOPLNEK",
    REMOVE_SELECTED_DOPLNEK: "REMOVE_SELECTED_DOPLNEK",
    SELECTED_VYBAVENI: "SELECTED_VYBAVENI",
    REMOVE_SELECTED_VYBAVENI: "REMOVE_SELECTED_VYBAVENI",
    
    //Filtering reducer toDel
    MODIFY_PRVKY: "MODIFY_PRVKY",
    
    //Menu managment
    CHANGE_MENU_SELECTION: "CHANGE_MENU_SELECTION",

    //Misc reducer constants
    SET_VIDITELNOST: "SET_VIDITELNOST",
    SET_POUZITI: "SET_POUZITI",
    SET_KLASIFIKACE: "SET_KLASIFIKACE",
    SET_RODINYPOVRCHU: "SET_RODINYPOVRCHU",
    SET_RODINYVYBAVENI: "SET_RODINYVYBAVENI",

    //Filtering managment
    SET_FILTERING_POVRCHY: "SET_FILTERING_POVRCHY",
    SET_FILTERING_DOPLNKY: "SET_FILTERING_DOPLNKY",
    SET_FILTERING_VYBAVENI: "SET_FILTERING_VYBAVENI",

    CHANGE_FILTERING_POVRCHY: "CHANGE_FILTERING_POVRCHY",
    CHANGE_FILTERING_DOPLNKY: "CHANGE_FILTERING_DOPLNKY",
    CHANGE_FILTERING_VYBAVENI: "CHANGE_FILTERING_VYBAVENI",

    //Filtering - NORMAL (ALL visibility===0 items)
    //SET_FILTERING_VISIBILITY: "SET_FILTERING_VISIBILITY",
    CHANGE_FILTERING_VISIBILITY: "CHANGE_FILTERING_VISIBILITY",

    //GENERAL, prolly not used
    SET_FILTERING: "SET_FILTERING",
    CHANGE_FILTERING: "CHANGE_FILTERING"
};